export const OPEN_BLANK_URL_TARGET = '_blank';
export const OPEN_SELF_URL_TARGET = '_self';

export type OpenBlankUrlTargetType = typeof OPEN_BLANK_URL_TARGET;
export type OpenSelfUrlTargetType = typeof OPEN_SELF_URL_TARGET;

export type UrlTargetType = OpenBlankUrlTargetType | OpenSelfUrlTargetType;
